import { render, staticRenderFns } from "./LearnerRegistrationPage.vue?vue&type=template&id=5f618033&scoped=true"
import script from "./LearnerRegistrationPage.vue?vue&type=script&lang=js"
export * from "./LearnerRegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./LearnerRegistrationPage.vue?vue&type=style&index=0&id=5f618033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f618033",
  null
  
)

export default component.exports